<script setup lang="ts">
  import type { StakeholderType } from '@gat-ship/types'
  import { IconClient, IconVendor, IconOrganization } from '../lucide-icons'
  import { computed, type HTMLAttributes } from 'vue'
  import { cn } from '../cn'

  const props = defineProps<{
    class?: HTMLAttributes['class']
    stakeholderType: StakeholderType
  }>()

  const _icon = computed(() => {
    switch (props.stakeholderType) {
      case 'client':
        return IconClient
      case 'vendor':
        return IconVendor
      case 'other':
        return IconOrganization
      default:
        return IconOrganization
    }
  })
</script>

<template>
  <component
    :is="_icon"
    :class="
      cn(
        'size-5',
        {
          'text-stakeholder-client': props.stakeholderType === 'client',
          'text-stakeholder-vendor': props.stakeholderType === 'vendor',
          'text-stakeholder-other': props.stakeholderType === 'other'
        },
        props.class
      )
    "
  />
</template>
